import { ProgramItem, ServiceItem, NewsItem, UmkmItem, StatItem } from "./types";

export const STATS_DATA: StatItem[] = [
  {
    id: "stat-warga",
    value: "1.250+",
    label: "WARGA",
    description: "Total warga terdaftar",
    iconName: "Users"
  },
  {
    id: "stat-kk",
    value: "340+",
    label: "KK",
    description: "Kepala Keluarga",
    iconName: "Home"
  },
  {
    id: "stat-rt",
    value: "6",
    label: "RT",
    description: "RT Aktif",
    iconName: "MapPin"
  },
  {
    id: "stat-umkm",
    value: "10+",
    label: "UMKM",
    description: "UMKM Warga",
    iconName: "Store"
  }
];

export const PROGRAMS_DATA: ProgramItem[] = [
  {
    id: "prog-rw-digital",
    iconName: "Monitor",
    title: "RW DIGITAL",
    description: "Pelayanan administrasi lebih mudah, cepat, dan transparan."
  },
  {
    id: "prog-info-terpadu",
    iconName: "Megaphone",
    title: "INFORMASI TERPADU",
    description: "Semua informasi lingkungan dalam satu portal yang selalu terupdate."
  },
  {
    id: "prog-masjid-digital",
    iconName: "Users",
    title: "INTEGRASI UKKT & ORGANISASI",
    description: "Informasi kegiatan UKKT & Organisasi yang ada di Lingkungan Cibubur Villa 2."
  },
  {
    id: "prog-umkm-naik-kelas",
    iconName: "Store",
    title: "UMKM NAIK KELAS",
    description: "Mendukung dan mempromosikan usaha warga Cibubur Villa 2."
  }
];

export const SERVICES_DATA: ServiceItem[] = [
  {
    id: "srv-pengantar",
    label: "Surat Pengantar",
    iconName: "FileText",
    description: "Ajukan surat pengantar RT/RW untuk berbagai kebutuhan administrasi."
  },
  {
    id: "srv-domisili",
    label: "Surat Domisili",
    iconName: "Home",
    description: "Surat keterangan domisili sebagai warga resmi RW 14."
  },
  {
    id: "srv-usaha",
    label: "Pendaftaran UMKM",
    iconName: "Store",
    description: "Daftarkan usaha & UMKM Anda untuk dipromosikan di katalog warga RW 14."
  },
  {
    id: "srv-aspirasi",
    label: "Aspirasi Warga",
    iconName: "MessageCircleCode",
    description: "Sampaikan ide, saran, maupun aspirasi untuk membangun RW 14."
  },
  {
    id: "srv-pengaduan",
    label: "Pengaduan",
    iconName: "AlertTriangle",
    description: "Laporkan masalah infrastruktur, keamanan, maupun ketertiban umum."
  },
  {
    id: "srv-agenda",
    label: "Agenda Kegiatan",
    iconName: "Calendar",
    description: "Lihat draf jadwal kerja bakti, rapat warga, posyandu & hari besar."
  }
];

export const NEWS_DATA: NewsItem[] = [
  {
    id: "news-1",
    category: "KEGIATAN",
    title: "Kerja Bakti Lingkungan Bersama Warga",
    date: "12 Mei 2025",
    image: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?q=80&auto=format,compress&w=600",
    excerpt: "Warga RW 14 Cibubur Villa 2 antusias menyelenggarakan kerja bakti massal guna membersihkan saluran air dan merapikan taman bermain anak demi menyambut musim hujan."
  },
  {
    id: "news-2",
    category: "PENGAJIAN",
    title: "Pengajian Rutin Al-Barokah",
    date: "10 Mei 2025",
    image: "/images/kegiatan_dkm00.jpeg",
    excerpt: "Majelis taklim Al-Barokah kembali mengadakan pengajian bulanan bersama Ustadz kondang dengan pemaparan kajian fikih ibadah yang dihadiri ratusan jamaah dengan hidmat."
  },
  {
    id: "news-3",
    category: "INFORMASI",
    title: "Posyandu Balita RT 03",
    date: "08 Mei 2025",
    image: "https://images.unsplash.com/photo-1502740479091-635887520276?q=80&auto=format,compress&w=600",
    excerpt: "Pelaksanaan penimbangan balita dan pemberian vitamin A gratis di gedung Sekretariat RT 03 berjalan lancar dengan pendampingan langsung oleh nakes Puskesmas setempat."
  }
];

export const UMKM_DATA: UmkmItem[] = [
  {
    id: "umkm-11",
    name: "Alfaza Parfum",
    category: "TOKO",
    whatsapp: "0857-7771-4237",
    image: "/images/alfaza_parfum.jpeg",
    description: "Menyediakan berbagai aroma parfum, dan siap custom parfum untuk souvenir, dan kado orang orang terkasih.",
    rating: 4.9
  },
  {
    id: "umkm-1",
    name: "Warung Sunda Bu RT",
    category: "KULINER",
    whatsapp: "0812-1234-5678",
    image: "/images/warung_sunda_bu_rt.jpeg",
    description: "Menyediakan ramesan lezat, kue tradisional, aneka lauk matang higienis, dan nasi kotak untuk pesanan hajatan warga.",
    rating: 4.9
  },
  {
    id: "umkm-2",
    name: "Gado-gado Pak Pangat",
    category: "KULINER",
    whatsapp: "0856-4084-4139",
    image: "/images/warung_khas_jawa_timur.jpeg",
    description: "Gado-gado siram khas dengan bumbu kacang kental, sayuran segar, dan emping renyah. Menerima pesanan untuk acara.",
    rating: 4.9
  },
  {
    id: "umkm-3",
    name: "Toko Kak Chia",
    category: "TOKO",
    whatsapp: "0858-8087-5824",
    image: "/images/toko_kak_chia.jpeg",
    description: "Menyediakan aneka jajanan, minuman ringan, dan kebutuhan sehari-hari warga dengan harga terjangkau.",
    rating: 4.9
  },
  {
    id: "umkm-4",
    name: "Kue Uni Dina",
    category: "KULINER",
    whatsapp: "0812-1200-2211",
    image: "/images/kue_uni_dinna.jpeg",
    description: "Menyediakan aneka kue basah, kue kering, dan jajanan pasar lezat dengan bahan berkualitas. Menerima pesanan untuk berbagai acara.",
    rating: 4.9
  },
  {
    id: "umkm-5",
    name: "Warung Bu Ana",
    category: "TOKO",
    whatsapp: "0813-8220-6307",
    image: "/images/warung_bu_anna.jpeg",
    description: "Menyediakan kebutuhan harian, sembako, dan aneka minuman.",
    rating: 4.9
  },
  {
    id: "umkm-6",
    name: "Warung Mama Omar",
    category: "TOKO",
    whatsapp: "0812-8609-1328",
    image: "/images/warung_mama_omar.jpeg",
    description: "Menyediakan aneka jajanan pasar, kopi, dan makanan ringan untuk bersantai.",
    rating: 4.9
  },
  {
    id: "umkm-7",
    name: "Warung Bu Ayu",
    category: "TOKO",
    whatsapp: "0812-9292-1795",
    image: "/images/warung_bu_ayu.jpeg",
    description: "Menjual perlengkapan rumah tangga dan kebutuhan sembako harian.",
    rating: 4.9
  },
  {
    id: "umkm-8",
    name: "KB - Insan Kariim",
    category: "PENDIDIKAN",
    whatsapp: "0821-2576-7726",
    image: "/images/paud_insan_kariim.jpeg",
    description: "Pendidikan anak usia dini dengan metode bermain sambil belajar bernuansa islami.",
    rating: 4.9
  },
  {
    id: "umkm-9",
    name: "Susu Murni Ust.Lukman",
    category: "KULINER",
    whatsapp: "0813-8763-6065",
    image: "/images/susu_segar_ust_lukman.jpeg",
    description: "Menyediakan susu murni segar dan aneka minuman.",
    rating: 4.9
  },
  {
    id: "umkm-10",
    name: "Sayur Mayur Uda Hendri",
    category: "TOKO",
    whatsapp: "0812-9528-8333",
    image: "/images/sayur_uda_hendri.jpeg",
    description: "Menjual sayur mayur segar dan bumbu dapur kebutuhan rumah tangga.",
    rating: 4.9
  }
];

export const SHOLAT_TIMES_TODAY = {
  tanggal: "Ahad, 22 Juni 2026",
  subuh: "04:38",
  syuruk: "05:54",
  dzuhur: "11:55",
  ashar: "15:16",
  maghrib: "17:52",
  isya: "19:06"
};
